<template>
  <div
    class="c-timer px-4 py-3 br--small"
  >
    <div class="d-flex align-items-center">
      <div class="text-center">
        <p class="mb-0 fs-21 fs-md-30 w-bold">{{ timer.time.d }}</p>
        <span class="mb-0 w-medium fs-14 d-block">días</span>
      </div>
      <span class="mx-2 mx-md-3 w-medium fs-14">:</span>
      <div class="text-center">
        <p class="mb-0 fs-21 fs-md-30 w-bold">{{ timer.time.h }}</p>
        <span class="mb-0 w-medium fs-14 d-block">horas</span>
      </div>
      <span class="mx-2 mx-md-3 w-medium fs-14">:</span>
      <div class="text-center">
        <p class="mb-0 fs-21 fs-md-30 w-bold">{{ timer.time.m }}</p>
        <span class="mb-0 w-medium fs-14 d-block">minutos</span>
      </div>
      <span class="mx-2 mx-md-3 w-medium fs-14">:</span>
      <div class="text-center">
        <p class="mb-0 fs-21 fs-md-30 w-bold">{{ timer.time.s }}</p>
        <span class="mb-0 w-medium fs-14 d-block">segundos</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      timer: {
        localTimer: 0,
        time: {
          d: 0,
          h: 0,
          m: 0,
          s: 0,
        },
        intervalTimer: 0,
      },
    };
  },
  props: ['end'],
  watch: {
    'timer.localTimer': function localTimer() {
      if (this.timer.localTimer > 0) {
        this.timer.time.s = Math.trunc(this.timer.localTimer % 60);
        this.timer.time.m = Math.trunc((this.timer.localTimer / 60) % 60);
        this.timer.time.h = Math.trunc(((this.timer.localTimer / 60) / 60) % 24);
        this.timer.time.d = Math.trunc((((this.timer.localTimer / 60) / 60) / 24));
      } else {
        this.finishTimer();
      }
    },
  },
  mounted() {
    this.$bvModal.show('welcomeModal');

    this.initTimer();
  },
  methods: {
    initTimer() {
      const expiredDate = new Date(this.end);
      const currentDate = new Date();

      if (expiredDate > currentDate) {
        this.timer.localTimer = Math.abs(expiredDate - currentDate) / 1000;

        if (this.timer.localTimer > 0) {
          this.timer.intervalTimer = window.setInterval(() => {
            this.timer.localTimer -= 1;
          }, 1000);
        } else {
          this.finishTimer();
        }
      } else {
        this.timer.localTimer = 0;

        this.finishTimer();
      }
    },
    finishTimer() {
      window.clearInterval(this.timer.intervalTimer);
    },
  },
};
</script>
